import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Isvg from 'react-inlinesvg';

import BackButton from '../lib/BackButton';
import '../../scss/DistrictDetail.scss';

import { sortRaces } from '../lib/sorting';

export default class DisctrictDetail extends Component {
  makeButton(path, slug, label, previous) {
    return (
      <li key={slug}>
        <Link
          className="DistrictDetail__issue"
          to={{
            pathname: `/${path}/${slug}`,
            state: {previous}
          }}>
          {label}
        </Link>
      </li>
    );
  }
  
  render() {
    let { router: {
      location: { state },
      match: { params: { district } },
    }, races } = this.props;
    let localRaces = sortRaces({
      district,
      races,
      boros: state && state.boro ? [state.boro] : []
    });
    let previous = `/districts/${district}`;

    return (
      <div className="DistrictDetail">
        <BackButton path='/' />
        {localRaces ? 
          <div>
            <h2 className="DistrictDetail__header">
              Contests on Your Ballot
            </h2>
        
            <h3 className="DistrictDetail__subhead">Choose a Race</h3>
            <ul className="DistrictDetail__issues">
              {localRaces.map(race => this.makeButton('races', race.slug, race.seat, previous))}
            </ul>
            
            <h3 className="DistrictDetail__subhead">Ballot Questions</h3>
            <ul className="DistrictDetail__issues">
              {this.props.ballotQuestions.map(question => this.makeButton('questions', question.slug, question.title, previous))}
            </ul>
          </div>
          :
          <h3 className="DistrictDetail__subhead">
            There are no citywide, boroughwide or City Council elections in your district.
          </h3>}

          <a href="https://nyc.pollsitelocator.com/search" className="DistrictDetail__pollsite" target="_blank" rel="noopener noreferrer">
            <Isvg src={`${ROOT_URL}assets/images/icons/location.svg`} className="location-icon" />
            You may have additional local races on your ballot. Click here for a sample ballot and to confirm your poll site.
          </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/routes/DistrictDetail.js